import { Link } from 'react-router-dom';
import RiskBadge from '@/components/base/RiskBadge';
import type { Incident } from '@/mocks/incidents';

export default function IncidentCard({
  incident,
  layout = 'vertical',
}: {
  incident: Incident;
  layout?: 'vertical' | 'horizontal';
}) {
  if (layout === 'horizontal') {
    return (
      <article className="group grid grid-cols-1 gap-4 border-b border-background-200 py-6 last:border-0 sm:grid-cols-[220px_1fr] md:gap-6">
        <Link
          to={`/incident/${incident.id}`}
          className="block h-40 w-full overflow-hidden rounded-lg bg-background-200 sm:h-full"
        >
          <img
            src={incident.cover}
            alt={`${incident.title} 配图`}
            title={`${incident.title} - 网站黑料安全事件`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </Link>
        <div className="flex flex-col">
          <div className="flex flex-wrap items-center gap-2">
            <RiskBadge level={incident.riskLevel} size="sm" />
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {incident.categoryName}
            </span>
            <span className="text-xs text-foreground-400">{incident.date}</span>
          </div>
          <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
            <Link to={`/incident/${incident.id}`} className="transition-colors hover:text-primary-700">
              {incident.title}
            </Link>
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{incident.summary}</p>
          <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-building-2-line text-[13px]"></i>
              </span>
              {incident.platform}
            </span>
            <span className="flex items-center gap-1">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-time-line text-[13px]"></i>
              </span>
              阅读约 {incident.readMinutes} 分钟
            </span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <Link to={`/incident/${incident.id}`} className="block h-44 w-full overflow-hidden bg-background-200">
        <img
          src={incident.cover}
          alt={`${incident.title} 配图`}
          title={`${incident.title} - 网站黑料安全事件`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
        />
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2">
          <RiskBadge level={incident.riskLevel} size="sm" />
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
            {incident.categoryName}
          </span>
        </div>
        <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">
          <Link to={`/incident/${incident.id}`} className="transition-colors hover:text-primary-700">
            {incident.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-3 flex-1 text-sm leading-6 text-foreground-600">
          {incident.summary}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span>{incident.date}</span>
          <span className="flex items-center gap-1 transition-colors group-hover:text-primary-700">
            查看详情
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-arrow-right-line text-[13px]"></i>
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}